import { render, staticRenderFns } from "./ThankyouPage.vue?vue&type=template&id=d908307e"
import script from "./ThankyouPage.vue?vue&type=script&lang=js"
export * from "./ThankyouPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports